import { computed as f, ref as l, watch as o } from "vue";
function n(e) {
  const a = f(e), u = l(a.value);
  return o(a, (t) => {
    u.value = t;
  }), typeof e == "function" ? u : {
    __v_isRef: !0,
    get value() {
      return u.value;
    },
    set value(t) {
      e.set(t);
    }
  };
}
export {
  n as default
};
